module.exports = __webpack_public_path__ + "0f9131a8768454cfeba661e9e362b06c.jpg";